import React, { useState, useContext } from 'react';
import './login.css';
import Bg from  '../../assets/slide4.jpg';
import Logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faInfo, faEye } from '@fortawesome/free-solid-svg-icons';

import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import { Link, useNavigate } from 'react-router-dom';
import BackLoader from '../../components/backloader'

function ForgetPassword() {
    const [staySigned, setStaySigned] = useState(false)
    const navigate = useNavigate();
    const { profile , setProfile, setToken} = useContext(ShareContext);

    const [seePass, setSeePass] = useState(false);
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);
    const [email, setEmail]=useState('');
    const [password, setPassword] = useState('');
    const [status, setStatus]= useState('');

    const onLogin=async(e)=>{
        e.preventDefault(); 
        setErr('')
        setStatus('')
          setLoading(true);
          
          try {
            var v={username:email,password:''};
            const resp = await fetch(`${Constants.apiUrl}/gazette/forgetpassword`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setStatus("Your credentials  sent to your email on record.");
            }else {   
              setErr('We cannot find the email on our system');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

  return (
    <div className='login'>
        <img src={Bg} className='bg-image' alt='Lagos City' />
        <div className="main">
            <div className="logo-text">
                <img src={Logo} alt="JIS Logo" className='jis-logo'/>
                <p><a href='http://jisstaging.lagosjudiciary.gov.ng/index.html'>Return to Judiciary home</a></p>
            </div>
            <div className="log-form">
                <div className="bar">
                    <div className="icon">
                        <FontAwesomeIcon icon={faInfo} />
                    </div>
                    <p>e-Affidavits</p>
                </div>
                <div className="main-form">
                    <h2>Forget Password</h2>
                    <form className="form" onSubmit={onLogin}>
                        <div className="input">
                            <label htmlFor="email">Email</label>
                            <input type="email" id='email' value={email} onChange={(e)=> setEmail( e.target.value )} required />
                        </div>
                       
                        <div className="continue-stay">
                            <div className="toggle">
                                <div className={staySigned ? "switch checked": "switch"}>
                                    <input type="checkbox" className="toggleBtnCheck" onClick={() => setStaySigned(!staySigned)}/>
                                    
                                </div>
                               
                            </div>
                            <button className='red' type="submit">Continue</button>
                        </div>
                        <div style={{color:'red', margin:8, textAlign:'center'}}>
                            {err}
                          </div>
                          <div style={{color:'green', margin:8, fontSize:18,fontWeight:'bold', textAlign:'center'}}>
                            {status}
                          </div>
                    </form>
                    <div className="reset">
                        <Link to='/login'>Login</Link>
                        <Link to='/signup'>Don't have an account? Sign up</Link>
                    </div>
                </div>
            </div>
        </div>
        <BackLoader open={loading}  />
    </div>
  )
}

export default ForgetPassword